module.exports = __webpack_public_path__ + "static/media/perfectWedding2.32e0e351.png";